import {
    FETCH_USERS, FETCH_USERS_SUCCESS, FETCH_USERS_FAILURE,
    SEND_USERS_CSV_START, SEND_USERS_CSV_SUCCESS, SEND_USERS_CSV_FAILURE,
    EMPTY_USERS, SET_USERS, SET_SORTED_USERS
} from './constants';

import { request, requestConfig } from 'utils/request';
import { PATHS } from 'utils/paths';

export const emptyUsers = () => ({
    type: EMPTY_USERS
});

const fetchUsers = (hideSpinner) => ({
    type: FETCH_USERS,
    hideSpinner
});

const fetchUsersSuccess = (data, meta) => ({
    type: FETCH_USERS_SUCCESS,
    data,
    meta
});

const fetchUsersFailure = (error) => ({
    type: FETCH_USERS_FAILURE,
    error
});

const sendUsersCsvStart = () => ({
    type: SEND_USERS_CSV_START
});

const sendUsersCsvSuccess = () => ({
    type: SEND_USERS_CSV_SUCCESS
});

const sendUsersCsvFailure = (error) => ({
    type: SEND_USERS_CSV_FAILURE,
    error
});

export const setUsers = (data) => ({
    type: SET_USERS,
    data
});

export const setSortedUsers = (data) => ({
    type: SET_SORTED_USERS,
    data
});


/**
 *  ASYNC ACTIONS
 */
export const getUsers = (isUpdate, filters) => (dispatch, getStore) => {
    dispatch(fetchUsers(isUpdate));

    let page = 0;

    if(isUpdate) {
        page = getStore().users.usersMetadata.page + 1;
    }

    let filterString = `&order=${filters.sortDirection}`;

    /*

   sortByName: 'create_at',
            sortByObj: 'user',
            sortDirection: 'DESC'
     */

    if(filters.sortByObj === 'company') {
        filterString += `&sort=company.${filters.sortByName}`;
    } else {
        filterString += `&sort=${filters.sortByName}`;
    }

    return request(PATHS.users.get(page, 25, filterString), requestConfig('GET', null, getStore().auth.token))
        .then((response) => {
            let users = response.data.users;
            if(isUpdate) {
                users = getStore().users.users.concat(response.data.users);
            }
            dispatch(fetchUsersSuccess(users, {page}));
            return response;
        })
        .catch((error) => {
            console.log('error', error);
            error.friendlyMessage = 'There was an error getting users. Please try again.';
            dispatch(fetchUsersFailure(error));
            throw error;
        });
};



export const sendUsersCsv = () => (dispatch, getStore) => {
    dispatch(sendUsersCsvStart());

    return request(PATHS.users.sendUsersCsv(), requestConfig('POST', null, getStore().auth.token))
        .then((response) => {
            dispatch(sendUsersCsvSuccess());
            return response;
        })
        .catch((error) => {
            console.log('error', error);
            error.friendlyMessage = 'There was an error sending a CSV of user data to your email. Please try again.';
            dispatch(sendUsersCsvFailure(error));
            throw error;
        });
};




// WEBPACK FOOTER //
// ./src/containers/UsersPage/store/actions.js